@if (currentParticipant$ | async; as currentParticipant) {
  <div class="container">
    <div class="main-header">
      <span class="main-heading-text" data-private>
        {{ currentParticipant.firstName }} {{ currentParticipant.lastName }} verification results
      </span>
      <p>
        Please review the credentials images and all of the information provided below to either approve or deny the
        credential uploaded by the signer sufficient for purposes of establishing the signer's identity
      </p>
    </div>
    <div class="license-container">
      @if ((idVerificationAndUserAddressResults$ | async)
        .latestUserAddressInformationIdVerificationResults; as idVerifyResult) {
        <app-id-images
          [idImages]="idVerifyResult.idImages"
        ></app-id-images>
      }
    </div>
    @if ((idVerificationAndUserAddressResults$ | async)
      .latestUserAddressInformationIdVerificationResults; as userAndIdVerifyResultAddressInfo) {
      <div class="address-information-container"
        >
        <app-address-information
      [addressInformation]="userAndIdVerifyResultAddressInfo.userAddressInformationIdVerificationResult
          .userAddressInformation"
          class="common-address-card"
        ></app-address-information>
        <app-address-information
      [addressInformation]="userAndIdVerifyResultAddressInfo.userAddressInformationIdVerificationResult
          .idVerificationResult"
          class="common-address-card"
        ></app-address-information>
      </div>
    }
    @if (
      (idVerificationAndUserAddressResults$ | async)
      .latestUserAddressInformationIdVerificationResults
      .userAddressInformationIdVerificationResult.idVerificationResult; as idVerifyResults) {
      <app-id-verification-results
        class="id-verify-results"
        [idVerifyResults]="idVerifyResults"
      ></app-id-verification-results>
    }
    @if ((idVerificationAndUserAddressResults$ | async).latestKbaResult; as kbaResults) {
      <app-kba-results
        class="kba-status-container"
        [kbaResults]="kbaResults"
      ></app-kba-results>
    }
    <div class="bottom-container">
      <div class="button-container">
        @if (isRejoiningParticipant$ | async) {
          <app-button
            type="primary"
            [dataTestId]="'approve-credentials'"
            (buttonClick)="approveRejoiningParticipant()"
            >
            Approve Rejoining Participant
          </app-button>
        }
        @if ((isRejoiningParticipant$ | async) === false) {
          <app-button
            type="primary"
            [dataTestId]="'approve-credentials'"
            (buttonClick)="approveParticipant()"
            >
            Approve Credentials
          </app-button>
        }
        @if (isRejoiningParticipant$ | async) {
          <app-button
            type="warning-secondary"
            [dataTestId]="'deny-credentials'"
            (buttonClick)="denyRejoiningParticipant()"
            >
            Deny Rejoining Participant
          </app-button>
        }
        @if ((isRejoiningParticipant$ | async) === false) {
          <app-button
            type="warning-secondary"
            [dataTestId]="'deny-credentials'"
            (buttonClick)="denyParticipant()"
            >
            Deny Credentials
          </app-button>
        }
      </div>
    </div>
  </div>
}
